import { render, staticRenderFns } from "./SupportPage.vue?vue&type=template&id=a5a24734&"
import script from "./SupportPage.vue?vue&type=script&lang=js&"
export * from "./SupportPage.vue?vue&type=script&lang=js&"
import style0 from "./SupportPage.vue?vue&type=style&index=0&id=a5a24734&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports